import { connect } from 'react-redux'
import { toggleLoginDialog } from '../actions'
import LoginDialog from '../components/LoginDialog'

const mapStateToProps = (state, ownProps) => ({
    isLoginDialogOpen: state.isLoginDialogOpen,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    toggleLoginDialog: isOpen => dispatch(toggleLoginDialog(isOpen)),
})

const ContainerLoginDialog = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginDialog)

export default ContainerLoginDialog


// WEBPACK FOOTER //
// ./src/containers/ContainerLoginDialog.js